import { castToOptionWithEmpty } from 'src/helpers/castToOption';

export enum CustomerLeadUrgency {
  Days_1_4 = 'DAYS_1_4',
  Days_5_7 = 'DAYS_5_7',
  Days_7_14 = 'DAYS_7_14',
  Days_15_30 = 'DAYS_15_30',
  Days_30More = 'DAYS_30_MORE',
}

export const CUSTOMER_LEAD_URGENCY_MAPPER: Readonly<Record<CustomerLeadUrgency, string>> = Object.freeze({
  [CustomerLeadUrgency.Days_1_4]: '1-4 days',
  [CustomerLeadUrgency.Days_5_7]: '5-7 days',
  [CustomerLeadUrgency.Days_7_14]: '7-14 days',
  [CustomerLeadUrgency.Days_15_30]: '15-30 days',
  [CustomerLeadUrgency.Days_30More]: 'More than 30 days',
});

export const CustomerLeadUrgencyOptions = castToOptionWithEmpty({
  enumeration: CustomerLeadUrgency,
  formatter: CUSTOMER_LEAD_URGENCY_MAPPER,
});
